var _rect, _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSplashLogo = function SvgSplashLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 175,
    viewBox: "0 0 175 175",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 175,
    fill: "#F66761"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.544 81.9896L125.307 58.7937C121.99 68.4981 121.753 72.2852 107.773 72.2852C96.3993 72.2852 89.5277 70.3916 85.7365 64.711C81.7083 70.6283 78.391 72.5219 63.4631 72.5219C51.6155 72.5219 52.3264 69.9182 48.5352 64.4743L49.0091 115.837H49.246C49.483 132.169 62.7522 138.086 87.6321 138.086C112.749 137.849 125.781 131.932 125.781 115.6V115.363L125.544 81.9896Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0656 40.332C57.0656 50.2732 58.4873 54.7703 68.6762 54.7703C78.8651 54.7703 80.0499 50.0365 80.0499 40.332H57.0656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5559 40.332C93.5559 50.2732 94.9776 54.7703 105.167 54.7703C115.355 54.7703 116.777 50.0365 116.54 40.332H93.5559Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSplashLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/splashLogo.d69c3411.svg";
export { ForwardRef as ReactComponent };